<template>
  <div id="withdraw">
    <headNav>
      <div slot="headNavText">{{$t('message.sch_tx')}}</div>
    </headNav>
    <div style="padding-top: 1.2rem"></div>
    <div class="withdraw_content">
      <div>
        <!--        <div class="withdraw_detail_title">{{$t('message.with_tx_ddxx')}}</div>-->
        <div class="" style="border-bottom: 1px dotted #E9E9E9;">
          <div style="padding: 12px 0 8px;font-size: 14px;color: #8E97A6;">{{$t('message.orderId')}}</div>
          <div style="padding: 8px 0;font-size: 14px;color: #8E97A6;">{{loanDate.orderid}}</div></div>
<!--        <div class="circle">-->
<!--          <div></div>-->
<!--          <div></div>-->
<!--        </div>-->
        <div class="item">
          <div>{{$t('message.with_tx_jkr')}}</div>
          <div>{{loanDate.username}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.with_tx_jkts')}}</div>
          <div>{{loanDate.loan_day}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.with_tx_jkje')}}</div>
          <div>{{add_comma_toThousands(loanDate.amount)}}{{coin}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.with_tx_dzje')}}</div>
          <div>{{add_comma_toThousands(loanDate.real_account)}}{{coin}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.with_tx_yhje')}}</div>
          <div>{{add_comma_toThousands((loanDate.amount-0)+(loanDate.interest-0))}}{{coin}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.with_tx_skyh')}}</div>
          <div>{{loanDate.bankname}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.with_tx_skzh')}}</div>
          <div>{{loanDate.bankcard}}</div>
        </div>
        <div class="item">
          <!--计息日期-->
          <div>Số ngày tính lãi</div>
          <!--实际放款日开始计息-->
          <div style="text-align: right">Tiền lãi được tính từ ngày giải ngân thực tế</div>
        </div>
      </div>
    </div>
    <div class="withdraw_mount_tips">
<!--      我同意由系统根据实际情况适当增加借款额度-->
      <van-checkbox v-model="checked" shape="square" checked-color="#8E97A6" icon-size="15px">Tôi đồng ý hệ thống dựa trên tình hình thực tế nâng cao hạn mức khoản vay</van-checkbox>
    </div>

    <div style="width: 90%;margin: 0.5rem auto">
      <van-button block round @click="loanMoney" id="btn" ref="btn" :disabled="isUpload">{{$t('message.with_tx_ljtx')}}</van-button>
    </div>

  </div>
</template>

<script>
  import headNav from "../../HeadNav/headNav";
  import {getLoanProgress, getBorrowlist, sassDetailRec, sasstxDetail, sasstx, withdrawTips} from '../../../ports/port'

  export default {
    name: "schedule",
    data() {
      return {
        actived: 0,//已经通过的长度
        textTitle: '',
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        isOrder: JSON.parse(sessionStorage.getItem('indexJH')),//获取是否有订单
        current_index: 1,
        loanDate: {},
        coin: this.$coin,
        isUpload:false,
        checked:true,
        defaultColor:this.$color,
        loan_status:1
      }
    },
    components: {
      headNav
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      this.$store.commit('edit', true);//打开全局的loading
      sasstxDetail({orderid: this.$route.query.orderid})
        .then(res => {
          this.loanDate = res.data.data;
          this.$store.commit('edit', false);//关闭全局的loading
        })
        .catch(err => {
          if (err.toString().indexOf('timeout') != -1) {
            this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            this.$store.commit('edit', false);//关闭全局的loading
          }
        })
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      loanMoney() {
        this.isUpload=true;
        this.$store.commit('edit', true);//关闭全局的loading
        this.loan_status = this.checked?1:2;
        sasstx({orderid: this.$route.query.orderid,loan_status:this.loan_status})
          .then(res => {
            this.$store.commit('edit', false);//关闭全局的loading
            if (res.data.code == 200) {
              let that = this;
              this.$toast({
                type: 'success',
                message: res.data.msg,
                onClose:()=>{
                  this.$router.push({path:'/schedule',query:{"index":1}});
                }
              });

            } else {
              this.$dialog.confirm({
                title: this.$t("message.deal_photo_cz"),
                message: 'Hiện bạn chưa có app rút được tiền, bạn có cho phép hệ thống tự động giải ngân app phù hợp trong vòng 48 giờ không?',//当前没有可提现订单，是否授权系统在接下来的48小时内，自动匹配合适的产品为您放款 ？
                confirmButtonText:'Uỷ quyền',//授权
                cancelButtonText:'Từ chối',//拒绝
                confirmButtonColor:this.$color
              })
                .then(() => {
                  // on confirm
                  this.$store.commit('edit', true);//关闭全局的loading
                  withdrawTips({orderid:this.$route.query.orderid})
                    .then(res=> {
                      this.$store.commit('edit', false);//关闭全局的loading
                      if (res.data.code == 200) {
                        this.$toast({
                          type: 'success',
                          message: res.data.msg,
                          onClose:()=>{
                            this.$router.push({path:'/schedule',query:{"index":1}});
                          }
                        });
                      } else {
                        this.$toast({
                          type: 'success',
                          message: res.data.msg,
                          onClose:()=>{
                            this.$router.push({path:'/schedule',query:{"index":1}});
                          }
                        });
                      }
                    })
                })
                .catch(() => {
                  this.$router.push({path:'/schedule',query:{"index":1}});
                });
            }
              // this.$toast({type: 'danger', message: res.data.msg});
              this.isUpload=false;
          })
          .catch(err => {
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
              this.$store.commit('edit', false);//关闭全局的loading
              this.isUpload=false;
            }
          })
      },
      //今个样式
      add_comma_toThousands(num) {
        var num = (num || 0).toString();
        let inc = num.indexOf('.');
        if (inc == -1) {
        } else {
          num = num.substring(0, inc);
        }
        var result = '';
        while (num.length > 3) {
          result = ',' + num.slice(-3) + result;
          num = num.slice(0, num.length - 3);
        }
        if (num) {
          result = num + result;
        }
        return result;
      },
    }
  }
</script>

<style scoped lang="scss">
  #withdraw {
    background: #F8F8F8;
    min-height: 100vh;

    .title {
      text-align: center;
      background: white;
      font-size: 16px;
      padding: 10px 0;
      border-bottom: 1px solid #F2F4FB;
      position: relative;

      i {
        position: absolute;
        left: 20px;
        font-size: 20px;
      }
    }

    .withdraw_content {
      width: 93%;
      margin: 15px auto;
      background: #fff;
      padding: 0 15px 0.2rem;
      box-sizing: border-box;
      border-radius: 15px;
      position: relative;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);

      .circle {
        :nth-child(1) {
          position: absolute;
          top: 1.15rem;
          left: -1px;
          z-index: 1;
          width: 8px;
          height: 16px;
          background-color: #F8F8F8;
          border-top: 1px solid rgba(122, 122, 122, 0.1);
          border-right: 1px solid rgba(122, 122, 122, 0.1);
          border-bottom: 1px solid rgba(122, 122, 122, 0.1);
          border-radius: 0 20px 20px 0; /* 左上、右上、右下、左下 */
        }

        :nth-child(2) {
          position: absolute;
          top: 1.15rem;
          right: -1px;
          z-index: 1;
          width: 8px;
          height: 16px;
          background-color: #F8F8F8;
          border-radius: 20px 0 0 20px; /* 左上、右上、右下、左下 */
          border-top: 1px solid rgba(122, 122, 122, 0.1);
          border-left: 1px solid rgba(122, 122, 122, 0.1);
          border-bottom: 1px solid rgba(122, 122, 122, 0.1);

        }
      }

      .withdraw_detail_title {
        font-size: 18px !important;
        font-weight: 600;
      }

      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.44rem 0;
        font-size: 14px;
        border-bottom: 1px dotted #E9E9E9;

        div {
          color: gray;
        }

        > div:nth-child(1) {
          color: #8E97A6;
        }
      }

    }

    #btn {
      @include defaultBtn
    }

    .withdraw_mount_tips {
      width: 90%;
      margin: 0 auto;
      font-size: 0.2rem;
      color: #8E97A6!important;
    }
    /deep/ .van-checkbox__label{
      color: #8E97A6!important;
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/withdraw/withdraw.vue